import { createFetchReducer } from '../helpers/fetchData'
import actions from './actions'

const items = createFetchReducer({ name: actions.itemsApiName })

export default items
